import React from "react";

import { isParentalConsentReady } from "state/school_money/selectors";

import Preloader from "components/school_money/Preloader";
import MaintainValidStudentID from "components/school_money/MaintainValidStudentID";
import StudentSelector from "components/school_money/StudentSelector";
import StudentCarousel from "components/school_money/StudentCarousel";
import StudentParentalConsentList from "components/school_money/parental_consent/StudentParentalConsentList";
import ParentalConsentErrorModal from "components/school_money/parental_consent/ParentalConsentErrorModal";
import ParentalConsentSuccessModal from "components/school_money/parental_consent/ParentalConsentSuccessModal";

import "./ParentalConsentPage.css";

export default class ParentalConsentPage extends React.Component {

  generatePath(studentID) {
    return `/school_money/parental_consent/${studentID}/`;
  }

  isParentalConsentReady = (state) => {
    return isParentalConsentReady(state, this.props.studentID);
  }

  render() {
    const { studentID } = this.props.match.params;
    return (
      <MaintainValidStudentID currentStudentID={studentID} generatePath={this.generatePath}>
        <ParentalConsentErrorModal />
        <ParentalConsentSuccessModal />
        <div className="parental-consent-page">
          <div className="page-header">
            <h1 className="page-header__title">Parental Consent</h1>
            <StudentSelector selectedStudentID={studentID} generatePath={this.generatePath} />
          </div>
          <Preloader isPageReady={this.isParentalConsentReady}>
            <StudentCarousel activeStudentID={studentID} generatePath={this.generatePath}>
              { studentID => <StudentParentalConsentList key={studentID} studentID={studentID} /> }
            </StudentCarousel>
          </Preloader>
        </div>
      </MaintainValidStudentID>
    )
  }

}



// WEBPACK FOOTER //
// ./src/components/school_money/parental_consent/ParentalConsentPage.js